/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon24Regular = forwardRef('GovKoRosreestrIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 9a8 8 0 1 1 8.662 7.973A6.75 6.75 0 0 1 6.95 23h-1.2a.75.75 0 0 1-.75-.75V9Zm1.543-.75a6.503 6.503 0 0 1 5.707-5.707V8.25H6.543Zm-.043 7.2v-5.7h5.75v5.7H6.5Zm0 1.5v4.55h.45a5.25 5.25 0 0 0 5.204-4.55H6.5Zm12.957-7.2a6.503 6.503 0 0 1-5.707 5.707V9.75h5.707ZM13.75 2.543a6.503 6.503 0 0 1 5.707 5.707H13.75V2.543Z" })));
});
